<article
	*ngIf="!!item"
	class="hero-item"
	role="group"
	aria-roledescription="slide"
	[attr.aria-label]="currentIndex + 1 + ' of ' + totalItemsCount"
>
	<wnz-hero-item-content
		class="item-content"
		[item]="item"
		[currentIndex]="currentIndex"
		[tabindex]="tabindex"
		[ngStyle]="{ 'background-color': item?.colourTheme.contentBgColor }"
		(ctaBtnClicked)="onSelectPromotion()"
	></wnz-hero-item-content>
	<wnz-hero-item-main-image
		class="item-main-image"
		[link]="item.buttonHref"
		[imageUrl]="item.mainImageUrl"
		[imageAltText]="item.mainImageAltText"
		(imageClicked)="onSelectPromotion()"
		[loadingStrategy]="loadingStrategy"
	></wnz-hero-item-main-image>
</article>
